export default __webpack_public_path__ + "static/media/Loader_Logo.71f3e51f.png";